import axios from "axios";
import { Form, Spinner } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { getFileExtension } from "../utils";
import { useState } from "react";

/**
 * @param {Object} props
 * @param {string} props.label
 * @param {string} props.id
 * @param {string} props.get
 */
export default function FileView({ label, id, get }) {
    const [loading, setLoading] = useState(false);
    const { watch, getValues } = useFormContext();
    const TextElement = get ? "a" : "p";

    async function openFile() {
        if (!get) {
            return;
        }

        setLoading(true);
        try {
            const { data } = await axios.get(`${get}/${getValues(id)._id}`);
            window.open(data.data, "_blank");
        } finally {
            setLoading(false);
        }
    }

    return (
        <Form.Group>
            <Form.Label className="mb-0">{label}</Form.Label>
            <div className="d-flex gap-2 align-items-center">
                <i className={`bi bi-file-earmark bi-filetype-${getFileExtension(watch(id)?.name).toLowerCase()} fs-4`} />
                <TextElement className={`text-start d-block mb-0 ${get ? "red-link" : ""}`} onClick={openFile}>{watch(id)?.name}</TextElement>
                {loading && <Spinner style={{ width: "1.5rem", height: "1.5rem" }} animation="border" />}
            </div>
        </Form.Group>
    );
}